import { useCallback } from 'react';
import { useBetterNavigate } from '../use-navigate';
import { parseQueryStringLens } from './parse-query-string-lens';
/**
 * Returns a setter function just like `useUrlQueryLens`,
 * but does not cause rerenders when the value changes.
 */
export function useSetUrlQueryLens(lens, navigateOptions) {
  const navigate = useBetterNavigate(navigateOptions);
  return useCallback((value, options) => {
    const l = parseQueryStringLens.then(lens);
    navigate(({
      search
    }) => ({
      search: l.set(typeof value === 'function' ? value(l.get(search)) : value, search)
    }), options);
  }, [lens, navigate]);
}